import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleRestrictionsProfilePresetsService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { RestrictionsProfileApiActions, RestrictionsProfileResolverActions } from './restrictions-profile.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class RestrictionsProfileEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: AppleRestrictionsProfilePresetsService
  ) {}

  loadSettingsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RestrictionsProfileResolverActions.profilesRequested),
      mergeMap(() =>
        safeMap(
          this.api.getRestrictionsProfilePresets('2.0'),
          (profiles) => RestrictionsProfileApiActions.profilesLoaded({ profiles }),
          (error) => RestrictionsProfileApiActions.profilesLoadedError({ error })
        )
      )
    );
  });
}
